import React, { Fragment, Component } from "react";
import Breadcrumb from "../../../components/common/breadcrumb";
import ProductInfo from "./productForm";
import ProductService from "../../../services/productService";
import BrandCategoryService from "../../../services/brandCategoryService";
// import store from "store";

class CreateProduct extends Component {
  state = {
    infoData: {},
    brandsList: [],
    categoryList: [],
  };
  componentWillMount() {
    const { match } = this.props;
    const { params } = match;
    const { productId } = params;
    BrandCategoryService.fetchBrandCategoryInfo().then((response) => {
      if (!response.error) {
        this.setState(
          {
            loader: true,
            productId,
            brandsList: response?.data?.brandList,
            categoryList: response?.data?.categoryList,
          },
          function () {
            this.callApiInfo();
          }
        );
      }
    });
  }

  callApiInfo = () => {
    const { productId } = this.state;
    ProductService.fetchProductsInfo(productId).then((response) => {
      if (!response.error) {
        console.log({ response: response.data });
        this.setState({
          loader: false,
          infoData: response.data,
          description: response.data.description,
          pictursList: response.data.pictursList,
          selectedCategoryId: response.data.categoryId._id,
          selectedBrandId: response.data.brandId._id,
          selectedSubCategory: response.data.subCategory,
          selectedBrandUrl: response.data.brandId.sUrl,
          selectedCategoryUrl: response.data.categoryId.sUrl,

          pdfFileName: response.data.pdfFileName,
          pdfFileUrl: response.data.pdfFileUrl,
        });
      } else {
        this.setState({
          loader: false,
          infoData: {},
        });
      }
    });
    this.setState({ loader: false });
  };

  addProductInfo = (data) => {
    const {
      pictursList,
      description,
      active,
      selectedBrandId,
      selectedCategoryId,
      selectedSubCategory,
      productId,
      selectedBrandUrl,
      selectedCategoryUrl,
      pdfFileName,
      pdfFileUrl,
      infoData,
    } = this.state;
    if (!selectedBrandId) {
      this.setState({ selectedBrandError: true });
      return;
    }
    if (!selectedCategoryId) {
      this.setState({ selectedCategoryError: true });
      return;
    }
    if (!selectedSubCategory) {
      this.setState({ selectedSubCategoryError: true });
      return;
    }
    data["productId"] = productId;
    data["pictursList"] = pictursList;
    data["description"] = description;
    data["active"] = active;
    data["brandUrl"] = selectedBrandUrl;
    data["categoryUrl"] = selectedCategoryUrl;
    data["brandId"] = selectedBrandId;
    data["categoryId"] = selectedCategoryId;
    data["subCategory"] = selectedSubCategory;
    data["pdfFileName"] = infoData.pdfFileName;
    data["pdfFileUrl"] = infoData.pdfFileUrl;
    data["fullUrl"] =
      selectedBrandUrl + "/" + selectedCategoryUrl + "/" + data["sUrl"];

    this.setState({ loader: true });
    ProductService.addProductInfo(data, "PUT").then((response) => {
      if (!response.error) {
        this.props.history.push("/products/all");
      }
    });
  };

  // onChangeUrl = (name, url) => {
  //   if ((name && name !== "") || (url && url !== "")) {
  //     console.log({ url });
  //     var { info, urlEdit } = this.state;
  //     var stringUrl = "";
  //     var urlEdit1 = false;
  //     if (name && !urlEdit) {
  //       stringUrl = name.toLowerCase();
  //     } else if (url) {
  //       stringUrl = url.toLowerCase();
  //       urlEdit1 = true;
  //     }
  //     stringUrl = stringUrl.replace(/ /g, "_");
  //     stringUrl = stringUrl.replace(/,/g, "_");
  //     stringUrl = stringUrl.replace(/__/g, "_");
  //     if (info) {
  //       info["sUrl"] = stringUrl;
  //     } else {
  //       info = { sUrl: stringUrl };
  //     }
  //     this.setState({ info: info, urlEdit: urlEdit1 });
  //   }
  // };

  onChangeUrl = (name, url) => {
    if (
      (name && name !== "") ||
      (url && url !== "undefined") ||
      (url === "" && url !== "undefined")
    ) {
      var { infoData, urlEdit } = this.state;
      var stringUrl = "";
      var urlEdit1 = true;
      if (name && !urlEdit) {
        stringUrl = name.toLowerCase();
        urlEdit1 = urlEdit || urlEdit1;
      } else if (url && url !== "undefined") {
        stringUrl = url.toLowerCase();
        urlEdit1 = true;
      } else if (url === "" && url !== "undefined") {
        stringUrl = url;
        urlEdit1 = false;
      } else {
        stringUrl = infoData["sUrl"] || "";
        urlEdit1 = urlEdit || urlEdit1;
      }
      stringUrl = stringUrl.replace(/ /g, "_");
      stringUrl = stringUrl.replace(/,/g, "_");
      stringUrl = stringUrl.replace(/__/g, "_");
      if (infoData) {
        infoData["sUrl"] = stringUrl;
      } else {
        infoData = { sUrl: stringUrl };
      }
      this.setState({ infoData: infoData, urlEdit: urlEdit1 });
    }
  };

  render() {
    const {
      infoData,
      brandsList,
      pictursList,
      categoryList,
      selectedBrandError,
      selectedCategoryError,
      selectedSubCategoryError,
      selectedCategoryId,
    } = this.state;
    console.log({ pictursList });
    // const propsDaterangePicker = {
    //   changeRangePicker: (startDate, endDate) => {
    //     //console.log({ startDate });
    //     //console.log({ endDate });
    //   }
    // };
    console.log({ infoData }, "@----------");
    const productInfoProps = {
      selectedBrandError: selectedBrandError,
      selectedCategoryError: selectedCategoryError,
      selectedSubCategoryError: selectedSubCategoryError,
      selectedCategoryId: selectedCategoryId,
      onChangeSubCategory: (selectedSubCategory) => {
        infoData.subCategory = selectedSubCategory;
        this.setState({
          infoData,
          selectedSubCategory,
          selectedSubCategoryError: false,
        });
      },
      active: this.state.active,
      pictursList: pictursList,
      onProductImageChange: (pictursList) => {
        console.log({ pictursList });
        this.setState({ pictursList });
      },
      productDescription: this.state.description,
      onChangeDescription: (description) => {
        console.log({ description });
        this.setState({ description });
      },
      info: infoData,
      onChangeUrl: this.onChangeUrl,
      searchProductUrl: "",
      searchUrlStatus: false,
      isEdit: true,
      onChangeCategoryId: (categoryId, url) => {
        infoData.categoryId = categoryId;
        this.setState({
          infoData,
          selectedCategoryId: categoryId,
          selectedCategoryUrl: url,
          selectedCategoryError: false,
        });
      },
      categoryList: categoryList,
      onChangeBrandId: (brandId, url) => {
        infoData.brandId = brandId;
        this.setState({
          infoData,
          selectedBrandId: brandId,
          selectedBrandUrl: url,
          selectedBrandError: false,
        });
      },
      brandsList: brandsList,
      // brandsList: [
      //   { _id: "_123", name: "Sony" },
      //   { _id: "_124", name: "Samsung" },
      //   { _id: "_125", name: "Lg" },
      //   { _id: "_126", name: "Hp" },
      // ],
      onClickActive: (active) => {
        this.setState({ active });
      },
      onClickConfirm: (data) => {
        console.log(data);
        this.addProductInfo(data);
      },
      pdfFileUrl: infoData.pdfFileUrl,
      onChangePdf: (pdfFileUrl) => {
        infoData["pdfFileUrl"] = pdfFileUrl;
        this.setState({ pdfFileUrl, infoData });
      },
      onChangePdfName: (pdfFileName) => {
        infoData["pdfFileName"] = pdfFileName;
        this.setState({ pdfFileName, infoData });
      },
      // productInfo: infoData,
    };

    return (
      <Fragment>
        <Breadcrumb title="Add" parent="Product" />
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                {infoData && infoData._id && (
                  <ProductInfo {...productInfoProps} />
                )}
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default CreateProduct;
